<template>
  <el-upload
    ref="upload"
    :action="action"
    :file-list="result.files"
    :data="data"
    :headers="headers"
    :disabled="Disable"
    :drag="showType === 'drag'"
    :limit="limit"
    :show-file-list="showFileList"
    :list-type="listType"
    :multiple="result.multiple"
    :before-upload="before"
    :on-progress="progress"
    :on-success="success"
    :on-error="error"
    :on-exceed="exceed"
    :class="{
        'hide-add-card': result.files.length >= limit || loading
      }"
  >
    <template #default>
      <div class="WHInherit" @click="updUid = undefined">
        <i v-if="showType === 'card'" class="el-icon-plus"/>

        <div
          v-if="showType === 'drag'"
          class="WHInherit"
          @dragenter="updUid = undefined"
        >
          <i class="el-icon-upload"/>
          <div class="el-upload__text block">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
        </div>

        <el-button v-if="showType === 'text'" type="primary" :size="size">
          {{ uploadText }}
        </el-button>
      </div>
    </template>

    <template #file="{ file }">
      <div v-if="showType === 'card'" class="WHInherit">
        <el-progress
          v-if="file.status === 'uploading'"
          class="flex-center HInherit"
          style="width: inherit"
          type="circle"
          :percentage="percent"
        />

        <div v-else :id="`id-${file.uid}-${file.domName}`" class="WHInherit">
          <h-preview :url="previewUrl(file)" width="100%" height="100%"/>
          <div class="el-upload-list__item-actions icons">
            <i class="el-icon-zoom-in" @click="preview(file)"/>
            <i class="el-icon-download" @click="download(file)"/>
            <i class="el-icon-delete" v-if="!Disable" @click="remove(file)"/>
            <i class="el-icon-edit" v-if="!Disable" @click="update(file)"/>
          </div>
        </div>
      </div>

      <div v-else>
        <el-progress
          v-if="file.status === 'uploading'"
          :percentage="percent"
          :text-inside="true"
          :stroke-width="20"
          striped
          striped-flow
          :duration="50"
        />

        <div v-else :id="`id-${file.uid}-${file.domName}`" class="flex-center-y hover">
          <h-preview :url="previewUrl(file)" width="15px" height="15px"/>
          <span class="pointer ML10 flex1" @click="preview(file)">
              {{ file.name }}
            </span>
          <div class="icons flex-center-y">
            <i class="el-icon-download" @click="download(file)"/>
            <i class="el-icon-delete MX5" v-if="!Disable" @click="remove(file)"/>
            <i class="el-icon-edit" v-if="!Disable" @click="update(file)"/>
          </div>
        </div>
      </div>
    </template>

    <template #tip>
      <div v-if="tip" class="el-upload__tip">
        {{ tip }}
      </div>
    </template>
  </el-upload>
</template>

<script>
import {fileLinkFileName, fileLinkFileType, type} from "otb-module/src/utils/tool";
import {supportFile} from "otb-module/packages/hUpload/src/supportFile"
import md5 from "js-md5";

export default {
  name: "hUpload",
  props: {
    action: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Array]
    },
    showType: {
      type: String,
      default: "card"
    },
    uploadText: {
      type: String,
      default: "点击上传"
    },
    tip: {
      type: String
    },
    size: {
      type: String,
      default: "small"
    },
    limit: {
      type: Number
    },
    multiple: {
      type: Boolean,
      default: false
    },
    showFileList: {
      type: Boolean,
      default: true
    },
    fileType: {
      type: [Array, String],
      default: () => []
    },
    fileSize: {
      type: Number,
      default: 50
    },
    disabled: {
      type: Boolean,
      default: false
    },
    headers: {
      type: Object,
      default: () => {
        return {};
      }
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    imgCheck: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      percent: undefined,
      updUid: undefined,
      result: {
        multiple: false,
        files: [],
        fileType: []
      },
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.result.files = []
        if (newVal) {
          if (type(newVal) === "Array") {
            for (const item of newVal) {
              if (type(item) === "Object") {
                if (!item.name) item.name = fileLinkFileName(item.url)
                item.domName = md5(item.name).toString();
                this.result.files.push(item)
              }
              if (type(item) === "String") {
                const name = fileLinkFileName(item)
                this.result.files.push({url: item, name, domName: md5(name).toString()})
              }
            }
          }
          if (type(newVal) === "String") {
            const name = fileLinkFileName(newVal)
            this.result.files = [{url: newVal, name, domName: md5(name).toString()}]
          }
        }
      },
      deep: true,
      immediate: true
    },
    multiple: {
      handler(newVal) {
        if (newVal) this.result.multiple = newVal
      },
      deep: true,
      immediate: true
    },
    fileType: {
      handler(newVal) {
        if (newVal) {
          let types = [];
          if (type(newVal) === "String") {
            if (newVal === "img") types = ["jpg", "jpeg", "png", "gif"];
            if (newVal === "office") types = ["pdf", "doc", "docx", "xsl", "xslx", "ppt", "pptx"];
            if (newVal === "video") types = ["mp4", "avi", "3gpp"];
            if (newVal === "audio") types = ["mp3"];
            if (newVal === "text") types = ["text"];
            if (newVal === "code") types = ["html", "css", "js", "json"];
          }
          if (type(newVal) === "Array") types = newVal;
          this.result.fileType = supportFile.filter((o) => types.includes(o.suffix));
        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    listType() {
      if (this.showType === "card") return "picture-card"
      return "text"
    },
    previewUrl() {
      return file => {
        return file.response && file.response.data ? file.response.data : file.url
      };
    },
    Disable() {
      return this.disabled || this.loading
    },
  },
  methods: {
    // 上传之前
    before(file) {
      // 上传格式校验
      if (this.result.fileType.length) {
        const supported = this.result.fileType.some((item) => item.type.includes(file.type));
        if (!supported) {
          const tip = this.result.fileType.map((o) => o.suffix).join(" ")
          this.$message.info(`仅支持上传 ${tip} 等格式`)
          return false
        }
      }
      // 上传大小校验
      if (file.size / 1024 / 1024 > this.fileSize) {
        this.$message.info(`上传文件大小不能超过${this.fileSize}Mb`)
        return false
      }
      // 上传图片校验
      if (["image/jpg", "image/jpeg", "image/png"].includes(file.type) && this.imgCheck) {
        // 按比例
        if (this.imgCheck.wh && this.imgCheck.wh.length === 2) {
          const width = this.imgCheck.wh[0];
          const height = this.imgCheck.wh[1];
          return new Promise((resolve, reject) => {
            let URL = window.URL || window.webkitURL;
            let img = new Image();
            img.onload = () => {
              let valid = width / height === img.width / img.height;
              if (!valid) {
                this.$message.info(`上传图片比例需为 ${width} / ${height}`);
                reject();
                return false;
              }
              resolve()
            };
            img.src = URL.createObjectURL(file);
          });
        }
        // 横图
        if (this.imgCheck.shape === "w") {
          return new Promise((resolve, reject) => {
            let URL = window.URL || window.webkitURL;
            let img = new Image();
            img.onload = () => {
              let valid = img.width > img.height;
              if (!valid) {
                this.$message.info(`上传图片比例需为横图`);
                reject();
                return false;
              }
              resolve()
            };
            img.src = URL.createObjectURL(file);
          });
        }
        // 竖图
        if (this.imgCheck.shape === "h") {
          return new Promise((resolve, reject) => {
            let URL = window.URL || window.webkitURL;
            let img = new Image();
            img.onload = () => {
              let valid = img.width < img.height;
              if (!valid) {
                this.$message.info(`上传图片比例需为竖图`);
                reject();
                return false;
              }
              resolve()
            };
            img.src = URL.createObjectURL(file);
          });
        }
        // 方图
        if (this.imgCheck.shape === "wh") {
          return new Promise((resolve, reject) => {
            let URL = window.URL || window.webkitURL;
            let img = new Image();
            img.onload = () => {
              let valid = img.width === img.height;
              if (!valid) {
                this.$message.info(`上传图片比例需为方图`);
                reject();
                return false;
              }
              resolve()
            };
            img.src = URL.createObjectURL(file);
          });
        }
      }
      this.loading = true;
    },
    // 文件上传时
    progress(evt, file, files) {
      this.percent = Math.ceil(evt.percent)
      this.$emit("progress", evt, file, files)
    },
    // 文件上传成功
    success(response, file, files) {
      // 编辑(替换)
      if (this.updUid) {
        file.update = true
        const nowIndex = files.findIndex((o) => o.uid === file.uid)
        const updIndex = files.findIndex((o) => o.uid === this.updUid)
        files[updIndex] = files.splice(nowIndex, 1)[0]
        if (this.multiple) this.result.multiple = this.multiple
      }
      this.$emit("update:value", files)
      this.$emit("success", response, file, files)
      this.result.files = files
      this.loading = false
    },
    // 文件删除(slot)
    remove(file) {
      // 自定义插槽的删除
      if (file.status === "success") {
        const index = this.result.files.findIndex((o) => o.uid === file.uid)
        this.result.files.splice(index, 1)
        this.$emit("update:value", this.result.files)
        this.$emit("remove", file, this.result.files)
      }
    },
    // 文件修改(slot)
    update(file) {
      this.updUid = file.uid
      if (this.multiple) this.result.multiple = false
      const dom = this.$refs.upload.$refs["upload-inner"].$refs.input
      this.$nextTick(() => dom.dispatchEvent(new MouseEvent("click")))
    },
    // 文件预览(slot)
    preview(file) {
      const url = file.response && file.response.data ? file.response.data : file.url
      const dom = ["jpg", "jpeg", "png"].includes(fileLinkFileType(url))
        ? document.querySelector(`#id-${file.uid}-${file.domName} .el-image__inner`)
        : document.querySelector(`#id-${file.uid}-${file.domName} .preview-iframe`)
      dom.dispatchEvent(new MouseEvent("click"))
    },
    // 文件上传失败
    error(error, file, files) {
      this.$message.error("上传失败，请重新上传！")
      this.loading = false
      this.$emit("error", error, file, files)
    },
    // 超出限制
    exceed(exceedFiles) {
      // limit为1时先清空(后上传)
      if (this.limit === 1 && !this.updUid) this.$refs.upload.clearFiles()
      // 新增/编辑先上传(后替换)
      if (exceedFiles.length === 1) {
        const file = exceedFiles[0]
        // file.uid = genFileId()
        this.$refs.upload.handleStart(file)
        this.$refs.upload.submit()
        return
      }
      this.$message.warning("超出所限制的上传数量！")
    },
    // 文件下载(slot)
    download(file) {
      const link = document.createElement("a")
      const url = file.response && file.response.data ? file.response.data : file.url
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          // 将链接地址字符内容转变成blob地址
          link.href = window.URL.createObjectURL(blob)
          link.download = file.name
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(link.href)
        })
        .catch(() => this.$emit("download", file))
    }
  }
}
</script>

<style scoped lang="scss">
.icons {
  justify-content: space-evenly;

  i {
    font-size: 16px;
    cursor: pointer;
    width: 1em;
    height: 1em;
  }
}

::v-deep .el-upload-list__item {
  line-height: normal;
}

// 新增或者达到上传上限 隐藏上传入口
.hide-add-card {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}

// 上传的圆形进度条按比例展示
::v-deep .el-progress-circle {
  width: 85% !important;
  height: 85% !important;
}

// 上传的拖拽区域
::v-deep .el-upload-dragger {
  padding: 0;
}

.hover {
  transition: 0.2s ease-in-out;

  &:hover {
    background-color: #eee2e2;
    color: #337ecc;
    transition: 0.2s ease-in-out;
  }
}
</style>
